// extracted by mini-css-extract-plugin
export default {"tag_container":"Tag_tag_container__wmNM-","tag_content":"Tag_tag_content__g3R5Y"};